import { FETCH_THEME_SUCCESS } from '../../actions/theme'

const initialState = {
  theme: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_THEME_SUCCESS:
      return {
        ...state,
        theme: action.theme,
      }
    default:
      return state
  }
}

export const getTheme = (state) => {
  return state.theme.theme
}
